import React, { useEffect, useState } from "react";
import { layoutStyle } from "../pages/layout-ui/style";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import {
  Settings as SettingsIcon,
  Sort as SortIcon,
  ViewColumn as ViewColumnIcon,
  ArrowForward as ArrowForwardIcon,
  Add as AddIcon
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "./SearchBar";
import * as XLSX from "xlsx";
import {
  useDriveTrain,
  useFleetList,
  useFuelList,
  useMake,
  useModel,
  useStates,
  useTypeList,
  useYear,
} from "../common/hooks";
import AddActionDialog from "./AddActionDialog";
import { useDebounce } from "./useDebounce";
import { setModelContentByActionFleetList } from "../common/constants/commonFunction";
import { uniqueNullValues } from "../common/constants/findNullValueGrid";
import { RequireFieldComponent } from "./RequireFieldComponent";
import { localStorageItemNames } from "../common/constants";
import { PageNameConstant } from "../common/constants/PageNameConstant";
import {
  getActiveSortRecord,
  onSortChanged,
} from "../common/utils/sortingColumn";
import { columnSortingMessage } from "../common/utils/columnSortingMessage";
import { SortingTextPopup } from "./SortingTextPopup";
import { DEALEAR_DEFAULT } from "../common/constants/dealer-name";

export const FleetHeaderButton = ({
  handleNext,
  handleClick,
  selectedRows,
  setSearchValue,
  anchorEl,
  handleOnClose,
  handleDeleteButton,
  companyId,
  setSelectedRows,
  rowDataFinal,
  clearAllFilters,
  columnChange,
  movableColumnData,
  setMovableColumnData,
  movableColumn,
  updateViewMovableColumn,
  createMovableColumn,
  setColumnChange,
  gridRef,
  columnFinal,
  setSortedColumn,
  setColumnFinal,
  sortableColumnData,
  createSortableColumn,
  updateViewSortableColumn,
  pageName,
}) => {
  const classes = layoutStyle();
  const [anchorElSearch, setAnchorElSearch] = useState(null);
  const navigation = useNavigate();
  const [actionButton, setActionButton] = useState("");
  const { fuelList, getFuelListApi } = useFuelList();
  const [modalContent, setModalContent] = useState("");
  const [dropdownValue, setDropDownValue] = useState([]);
  const [keyValue, setKeyValue] = useState("");
  const { year, getYearApi } = useYear();
  const { make, getMakeApi } = useMake();
  const { typeList, getTypeListApi } = useTypeList();
  const { driveTrainList, getDriveTrainListApi } = useDriveTrain();
  const { modelData, getModelList } = useModel();
  const { stateList, getStateListApi } = useStates();
  const { requireFields, setRequireFields } = useFleetList();
  const [openSortingPopup, setOpenSortingPopup] = useState(false);

  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  const handleExport = () => {
    const cleanedRows = selectedRows?.map((row) => {
      const { dealer, dealerName, dealerId, ...rest } = row;
      return rest;
    });
    const worksheet = XLSX.utils.json_to_sheet(cleanedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Current Fleet Details");
    XLSX.writeFile(workbook, "FleetList.xlsx");
  };
  const handleActionSelect = (action, value, key) => {
    setActionButton(action);
    handleOnClose();
    setModelContentByActionFleetList({
      action: action,
      key: key,
      selectedRows: selectedRows,
      handleExport: handleExport,
      handleDeleteButton: handleDeleteButton,
      setKeyValue: setKeyValue,
      setModalContent: setModalContent,
    });
  };

  useEffect(() => {
    if (actionButton == "setFuel") {
      getFuelListApi();
    } else if (actionButton == "setYear") {
      getYearApi();
    } else if (actionButton == "setMake") {
      getMakeApi();
    } else if (actionButton == "setModel") {
      if (selectedRows?.length > 0) {
        let array = [...new Set(selectedRows.map((item) => item.makeId))];
        getModelList({
          makeId: selectedRows[0]?.makeId,
          yearId: selectedRows[0]?.yearId,
        });
      }
    } else if (actionButton == "setDriveTrain") {
      getDriveTrainListApi();
    } else if (actionButton == "setType") {
      getTypeListApi();
    } else if (actionButton == "setAll") {
      getFuelListApi();
      getTypeListApi();
      getDriveTrainListApi();
      getStateListApi();
    } else if (actionButton === "State") {
      getStateListApi();
    }
  }, [actionButton]);

  const closeModal = (e) => {
    if (e === "save") {
      setSelectedRows([]);
    }
    setModalContent("");
    setDropDownValue([]);
    setActionButton("");
  };
  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    setAnchorElSearch(event.currentTarget);
  };
  useEffect(() => {
    if (actionButton == "setFuel") {
      setDropDownValue(fuelList);
    } else if (actionButton == "setYear") {
      setDropDownValue(year);
    } else if (actionButton == "setMake") {
      setDropDownValue(make);
    } else if (actionButton == "setModel") {
      setDropDownValue(modelData);
    } else if (actionButton == "setDriveTrain") {
      setDropDownValue(driveTrainList);
    } else if (actionButton == "setType") {
      setDropDownValue(typeList);
    } else if (actionButton == "setAll") {
      setDropDownValue({
        typeListArray: typeList,
        fuelListArray: fuelList,
        driveTrainListArray: driveTrainList,
        yearArray: year,
        state: stateList,
      });
    } else if (actionButton === "State") {
      setDropDownValue(stateList);
    }
  }, [modelData, make, year, driveTrainList, typeList, fuelList, stateList]);

  useEffect(() => {
    if (rowDataFinal?.length > 0) {
      const values = uniqueNullValues(rowDataFinal);
      if (values === "") {
        setRequireFields([]);
      } else {
        setRequireFields(values);
      }
    }
  }, [rowDataFinal]);

  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        SortedColumn: JSON.stringify(columnFinal),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        ColumnName: JSON.stringify(colNamesIndex),
        SortedColumn: JSON.stringify(columnFinal),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    }
    setColumnChange(false);
  };

  const onSortedColumnChange = async () => {
    if (sortableColumnData?.length) {
      setOpenSortingPopup(true);
      return;
    }
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      pageName
    );
  };
  const onSortedColumnChangeAlready = onSortedColumnChange;
  return (
    <Box>
      <Box className={classes.addEditGrid} sx={{ gap: "8px" }}>
        {rowDataFinal?.length > 0 && (
          <RequireFieldComponent
            classes={classes}
            requireFields={requireFields}
          />
        )}
        <Box className={classes.sortingFieldText}>
          {columnSortingMessage(sortableColumnData)}
        </Box>

        {getActiveSortRecord(sortableColumnData) ? (
          <Button
            variant="outlined"
            onClick={onSortedColumnChangeAlready}
            sx={{
              color: "#0860d3 !important",
              borderColor: "rgba(56, 189, 248, 0.4) !important",
              textTransform: "capitalize !important",
              borderRadius: "8px !important",
              padding: "6px 14px !important",
              fontWeight: "600 !important",
              transition: "all 0.2s ease-in-out !important",
              background: "rgba(56, 189, 248, 0.03) !important",
              "&:hover": {
                background: "rgba(56, 189, 248, 0.12) !important",
                borderColor: "#0860d3 !important",
                boxShadow: "0 0 10px rgba(56, 189, 248, 0.25) !important",
              }
            }}
            startIcon={<SortIcon style={{ fontSize: 16 }} />}
          >
            Save Sort
          </Button>
        ) : (
          <Button
            variant="outlined"
            onClick={onSortedColumnChange}
            sx={{
              color: "#0860d3 !important",
              borderColor: "rgba(56, 189, 248, 0.4) !important",
              textTransform: "capitalize !important",
              borderRadius: "8px !important",
              padding: "6px 14px !important",
              fontWeight: "600 !important",
              transition: "all 0.2s ease-in-out !important",
              background: "rgba(56, 189, 248, 0.03) !important",
              "&:hover": {
                background: "rgba(56, 189, 248, 0.12) !important",
                borderColor: "#0860d3 !important",
                boxShadow: "0 0 10px rgba(56, 189, 248, 0.25) !important",
              }
            }}
            startIcon={<SortIcon style={{ fontSize: 16 }} />}
          >
            Save Sort
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={handleMovableColumn}
          sx={{
            color: "#0860d3 !important",
            borderColor: "rgba(56, 189, 248, 0.4) !important",
            textTransform: "capitalize !important",
            borderRadius: "8px !important",
            padding: "6px 14px !important",
            fontWeight: "600 !important",
            transition: "all 0.2s ease-in-out !important",
            background: "rgba(56, 189, 248, 0.03) !important",
            "&:hover": {
              background: "rgba(56, 189, 248, 0.12) !important",
              borderColor: "#0860d3 !important",
              boxShadow: "0 0 10px rgba(56, 189, 248, 0.25) !important",
            }
          }}
          startIcon={<ViewColumnIcon style={{ fontSize: 16 }} />}
        >
          Save Columns
        </Button>
        {requireFields?.length === 0 && (
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              color: "white !important",
              background: "linear-gradient(135deg, #10B981 0%, #059669 100%) !important",
              textTransform: "capitalize !important",
              borderRadius: "8px !important",
              padding: "6px 16px !important",
              fontWeight: "600 !important",
              transition: "all 0.2s ease-in-out !important",
              boxShadow: "0 4px 10px rgba(16, 185, 129, 0.3) !important",
              "&:hover": {
                boxShadow: "0 6px 15px rgba(16, 185, 129, 0.5) !important",
                transform: "translateY(-1px)",
              }
            }}
            endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
          >
            Next
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={handleClick}
          disabled={selectedRows.length === 0}
          sx={{
            color: "#0F172A !important",
            borderColor: "rgba(148, 163, 184, 0.5) !important",
            textTransform: "capitalize !important",
            borderRadius: "8px !important",
            padding: "6px 14px !important",
            fontWeight: "600 !important",
            transition: "all 0.2s ease-in-out !important",
            background: "rgba(241, 245, 249, 0.9) !important",
            "&:hover": {
              background: "rgba(226, 232, 240, 0.85) !important",
              borderColor: "rgba(148, 163, 184, 0.7) !important",
            },
            "&.Mui-disabled": {
              color: "rgba(100, 116, 139, 0.5) !important",
              borderColor: "rgba(148, 163, 184, 0.25) !important",
            }
          }}
          startIcon={<SettingsIcon style={{ fontSize: 16 }} />}
        >
          Action
        </Button>
        <Button
          variant="contained"
          onClick={() => navigation("/new-fleetlist")}
          sx={{
            color: "white !important",
            background: "linear-gradient(90deg, #0555aa 0%, #0860d3 100%) !important",
            textTransform: "uppercase !important",
            borderRadius: "8px !important",
            padding: "6px 18px !important",
            fontWeight: "700 !important",
            transition: "all 0.2s ease-in-out !important",
            boxShadow: "0 4px 12px rgba(5, 85, 170, 0.35) !important",
            "&:hover": {
              boxShadow: "0 6px 18px rgba(56, 189, 248, 0.55) !important",
              transform: "translateY(-1px)",
            }
          }}
          startIcon={<AddIcon style={{ fontSize: 16 }} />}
        >
          NEW
        </Button>
        <SearchBar onSearch={onSearch} />
      </Box>
      <>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleOnClose}
        >
          <MenuItem
            onClick={() => handleActionSelect("delete", modelData, "model")}
          >
            Delete
          </MenuItem>
          <MenuItem onClick={() => handleActionSelect("export")}>
            Export
          </MenuItem>
          <MenuItem
            onClick={() => handleActionSelect("setFuel", fuelList, "name")}
          >
            Set Fuel
          </MenuItem>
          <MenuItem
            onClick={() => handleActionSelect("setType", typeList, "name")}
          >
            Set Type
          </MenuItem>
          {/* Hide because client require to hide for now */}
          {/* <MenuItem
            onClick={() =>
              handleActionSelect("setDriveTrain", driveTrainList, "name")
            }
          >
            Set Drive Train
          </MenuItem> */}
          <MenuItem onClick={() => handleActionSelect("setYear", year, "year")}>
            Set Year
          </MenuItem>
          <MenuItem onClick={() => handleActionSelect("setMake", make, "name")}>
            Set Make
          </MenuItem>
          <MenuItem
            onClick={() => handleActionSelect("setModel", modelData, "model")}
          >
            Set Model
          </MenuItem>
          <MenuItem onClick={() => handleActionSelect("setMPG", "", "mpg")}>
            Set MPG
          </MenuItem>
          {/* //Hide because client require to hide for now */}
          {/* <MenuItem
            onClick={() => handleActionSelect("groupType", "", "groupType")}
          >
            Set Group Type
          </MenuItem> */}
          <MenuItem
            onClick={() => handleActionSelect("State", stateList, "State")}
          >
            Set Location
          </MenuItem>
          <MenuItem
            onClick={() => handleActionSelect("driverName", "", "driverName")}
          >
            Set Driver Name
          </MenuItem>
          <MenuItem onClick={() => handleActionSelect("setAll", "", "data")}>
            Set All
          </MenuItem>
        </Menu>
      </>

      <AddActionDialog
        modalContent={modalContent}
        closeModal={closeModal}
        selectedRows={selectedRows}
        dropdownValue={dropdownValue}
        keyValue={keyValue}
        companyId={companyId}
      />

      {openSortingPopup && (
        <SortingTextPopup
          open={openSortingPopup}
          setOpen={setOpenSortingPopup}
          gridRef={gridRef}
          setSortedColumn={setSortedColumn}
          setColumnFinal={setColumnFinal}
          columnFinal={columnFinal}
          sortableColumnData={sortableColumnData}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.fleetList}
        />
      )}
    </Box>
  );
};
